export default __webpack_public_path__ + "static/media/twitter.3ff2c6c6.svg";